import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js'; //imports

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private http: HttpClient) { }

  forgotPassword
    (payLoad: {
      email: string,
      emailTemplateId: string, newPathname: string
    }) {
    return this.http.post(`/Account/ForgotPassword`, {
      Email: payLoad.email,
      EmailTemplateId: payLoad.emailTemplateId,
      Host: window.location.origin + '/' + payLoad.newPathname,
    });

  }

  checkUserOptionValidation(validationArray) {
    return this.http.post('/Account/CheckUserOptionValidation', validationArray);
  }

  signup(signUpObject) {
    return this.http.post('/Account/register', signUpObject);
  }

  sendCode(data, requestOptions) {
    return this.http.post(`/Account/SendCode`, data, requestOptions)
  }

  VerifyCode(data, requestOptions) {
    return this.http.post(`/Account/VerifyCode`, data, requestOptions)
  }

  ChangePassword(data) {
    return this.http.post(`/Account/ChangePassword`, data);
  }

  ResetPassword(data) {
    return this.http.post(`/Account/ResetPassword`, data);
  }

  GetUserByUserOption(userOptionValue: string, userOptionKey: string) {
    return this.http.get(`/Account/GetUserByUserOption/${userOptionValue}/${userOptionKey}`)
  }

  AddUpdateUserOptions(registrationId: string, useroptionsList : any[]) {
    return this.http.post(`/Account/AddUpdateUserOptions/${registrationId}`,useroptionsList)
  }




  GetUserInfo(username?: string) {
    const APIUrl = username ? `/Account/GetUserInfo/${username}` : `/Account/GetUserInfo`
    return this.http.get(APIUrl)
  }

  EditProfile(formData) {
    return this.http.put(`/Account/EditProfile`, formData);
  }


  encryptSecretKey = "DCMS@RAD123"; //adding secret key

  //Data Encryption Function
  encryptData(msg) {
    var keySize = 256;
    var salt = CryptoJS.lib.WordArray.random(16);
    var key = CryptoJS.PBKDF2(this.encryptSecretKey, salt, {
      keySize: keySize / 32,
      iterations: 100
    });

    var iv = CryptoJS.lib.WordArray.random(128 / 8);

    var encrypted = CryptoJS.AES.encrypt(msg, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });

    var result = CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));

    return result;
  }

  decrypt( ciphertextB64) {

    var key = CryptoJS.enc.Utf8.parse(this.encryptSecretKey);
    var iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);

    var decrypted = CryptoJS.AES.decrypt(ciphertextB64, key, { iv: iv });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

}
